import React from 'react'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import HomeScreen from '../screens/HomeScreen'
import ProfileScreen from '../screens/ProfileScreen'
import SettingsScreen from '../screens/SettingsScreen'
// import Initialize from '../screens/SubmissionFlow/Initialize'
import UseCamera from '../screens/SubmissionFlow/UseCamera'
import MapScreen from '../screens/MapScreen'
import Icon from 'react-native-vector-icons/Ionicons'
import Initialize from '../screens/SubmissionFlow/Initialize'

const Tab = createBottomTabNavigator()

const NavigationBar = () => {
    return (
        <Tab.Navigator
            screenOptions={({ route }) => ({
                tabBarIcon: ({ focused, color, size, style }) => {
                    let iconName

                    if (route.name === 'Home') {
                        iconName = focused ? 'home' : 'home-outline'
                    } else if (route.name === 'Profile') {
                        iconName = focused ? 'person-circle' : 'person-circle-outline'
                    } else if (route.name === 'Submit') {
                        iconName = focused ? 'add' : 'add-outline'
                    } else if (route.name === 'Map') {
                        iconName = focused ? 'map' : 'map-outline'
                    } else if (route.name === 'Settings') {
                        iconName = focused ? 'cog' : 'cog-outline'
                    }

                    return <Icon name={iconName} size={size} color={color} />
                },
                tabBarActiveTintColor: '#6c387a',
                tabBarInactiveTintColor: 'gray',
            })}
        >
            <Tab.Screen name="Home" component={HomeScreen} options={{ headerShown: false }} />
            <Tab.Screen name="Profile" component={ProfileScreen} options={{ headerShown: false }} />
            <Tab.Screen name="Submit" component={Initialize} options={{ headerShown: false }} />
            <Tab.Screen name="Map" component={MapScreen} options={{ headerShown: false }} />
            <Tab.Screen name="Settings" component={SettingsScreen} options={{ headerShown: false }} />
        </Tab.Navigator>
    )
}

export default NavigationBar
